import { useHistory } from "react-router";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "src/colors/colors";
import StepsPayment from "src/components/homePage/components/steps/steps";
import useCheckMobile from "src/hook/useCheckMobile";
import { useCheckLoading } from "src/providers/checkLoadingProvider";
import QrPayContent from "./QrPayContent";

const QrPage = (props) => {
  const history = useHistory();
  const isMobile = useCheckMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const { setIsLoading } = useCheckLoading();

  return (
    <div>
      {/* {<HeaderTitle>Đóng phí bảo hiểm</HeaderTitle>} */}
      <StepsPayment step={2} onPressStep={() => { }} />
      <div
        style={{
          backgroundColor: colors.background.white,
          borderRadius: "16px",
          marginBottom: "20px"
        }}

      >
        <QrPayContent isCheckPayStatus={true} />
      </div>
    </div>
  );
};

export default QrPage;


